import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=493b59f0&scoped=true"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"
import style0 from "./scss/index.scss?vue&type=style&index=0&id=493b59f0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493b59f0",
  null
  
)

export default component.exports